import { SalesOrderLine } from './sales-order-line';

export interface SalesContractLine {
  id: string;
  contractNo: number;
  description: string;
  productKey: string;
  productDescription: string;
  unitOfMeasure: string;
  quantity: number;
  price: number;
  contractValue: number;
  contractLineBalanceValue: number;
  contractLineBalance: number;

  salesOrderLines: SalesOrderLine[];
}
